import { queryOptions } from '@tanstack/react-query';
import {
  getMerchantProductDetail,
  getMerchantProductReceipts,
  getMerchantProducts,
} from './inventory.service';
import type { MerchantProductReceiptsQueryParams, MerchantProductsQueryParams } from './types';

export const merchantProductsQueryKeyPrefix = ['merchant', 'products'] as const;

export function merchantProductsQueryOptions(params: MerchantProductsQueryParams) {
  return queryOptions({
    queryKey: [
      ...merchantProductsQueryKeyPrefix,
      params.q ?? null,
      params.sort ?? null,
      params.category ?? null,
      params.is_hidden ?? null,
      params.missing_image ?? null,
      params.branch_id ?? null,
      params.page ?? null,
      params.page_size ?? null,
    ],
    queryFn: () => getMerchantProducts(params),
    staleTime: 30_000,
  });
}

export function merchantProductDetailQueryOptions(productId: string) {
  return queryOptions({
    queryKey: ['merchant', 'product-detail', productId],
    queryFn: () => getMerchantProductDetail(productId),
    staleTime: 30_000,
  });
}

export function merchantProductReceiptsQueryOptions(
  productId: string,
  params: MerchantProductReceiptsQueryParams,
) {
  return queryOptions({
    queryKey: [
      'merchant',
      'product-receipts',
      productId,
      params.q ?? null,
      params.branch_id ?? null,
      params.page ?? null,
      params.page_size ?? null,
    ],
    queryFn: () => getMerchantProductReceipts(params),
    staleTime: 30_000,
  });
}
